class HomeResults {
    constructor() {
        this.images = document.querySelectorAll('.result__image')

        this.images.forEach(image => image.addEventListener('click', this.toggleImageView))
    }

    toggleImageView(event) {
        const images = document.querySelectorAll('.result__image')
        const selectedImage = event.target

        images.forEach(image => {
            if (image === selectedImage) {
                image.parentNode.classList.toggle('result__image-container_expanded')
                image.classList.toggle('result__image_expanded')
            } else {
                image.parentNode.classList.remove('result__image-container_expanded')
                image.classList.remove('result__image_expanded')
            }
        })
    }
}

export default HomeResults
